import { Avatar } from '@picsart/design-system/components/Avatar';
import {
  InlineButton,
  ControlSizesMD,
  InlineButtonAlignments,
} from '@picsart/design-system/components/InlineButton';
import { IconLogout } from '@picsart/design-system/foundation/icons/IconLogout';
import { IconCoins } from '@picsart/design-system/foundation/icons/IconCoins';
import { IconSettings } from '@picsart/design-system/foundation/icons/IconSettings';
import { IconAccounts } from '@picsart/design-system/foundation/icons/IconAccounts';
import useStyles from './styles';
import type { UserMenuContentProps } from './types';

const UserMenuContent = ({
  isAuthorized,
  username,
  avatarSrc,
  avatarBadge,
  credits,
  onCreditsClick,
  onSettingsClick,
  onLogout,
  onSignIn,
}: UserMenuContentProps) => {
  const classes = useStyles();

  return (
    <>
      {isAuthorized && (
        <div className={classes.userCard}>
          <Avatar size={44} imageSrc={avatarSrc} badge={avatarBadge} />
          <div className={classes.userInfo}>
            <span className={classes.userName}>{username}</span>
            <span className={classes.userHandle}>@{username}</span>
          </div>
        </div>
      )}

      <div className={classes.menuSection}>
        {isAuthorized && credits !== null && (
          <InlineButton
            className={classes.actionButton}
            dataTestId="genai-user-menu-open-credits"
            size={ControlSizesMD}
            startIcon={IconCoins}
            alignment={InlineButtonAlignments.Start}
            isFullWidth
            isWithoutBorder
            onClick={onCreditsClick}
          >
            <span className={classes.creditsRow}>
              <span>Credits</span>
              <span className={classes.creditsValue}>
                {credits.toLocaleString()}
              </span>
            </span>
          </InlineButton>
        )}

        {onSettingsClick && (
          <InlineButton
            className={classes.actionButton}
            dataTestId="genai-user-menu-settings"
            size={ControlSizesMD}
            startIcon={IconSettings}
            alignment={InlineButtonAlignments.Start}
            isFullWidth
            isWithoutBorder
            onClick={onSettingsClick}
          >
            Settings
          </InlineButton>
        )}

        {isAuthorized ? (
          <InlineButton
            className={classes.actionButton}
            dataTestId="genai-user-menu-logout"
            size={ControlSizesMD}
            startIcon={IconLogout}
            alignment={InlineButtonAlignments.Start}
            isFullWidth
            isWithoutBorder
            onClick={onLogout}
          >
            Log out
          </InlineButton>
        ) : (
          <InlineButton
            className={classes.actionButton}
            dataTestId="genai-user-menu-sign-in"
            size={ControlSizesMD}
            startIcon={IconAccounts}
            alignment={InlineButtonAlignments.Start}
            isFullWidth
            isWithoutBorder
            onClick={onSignIn}
          >
            Sign in
          </InlineButton>
        )}
      </div>
    </>
  );
};

export default UserMenuContent;
